import React, { useMemo, useState } from 'react';
import { SnackbarProvider } from 'fronton-react';
import {
  TData,
  DataContext,
  RouteContext,
} from 'entries/common/widgets/saved-project-configuration/context';
import { Content } from './content';
import { routes } from './consts/routes';

export const SavedProjectConfigurationPage = ({ data: initialData }: { data: TData }) => {
  const [data, setData] = useState(initialData);
  const [route, setRoute] = useState(routes.calculation);
  const routeProviderValue = useMemo(() => ({ route, setRoute }), [route]);
  const dataProviderValue = useMemo(() => ({ data, setData }), [data]);

  return (
    <DataContext.Provider value={dataProviderValue}>
      <SnackbarProvider>
        <RouteContext.Provider value={routeProviderValue}>
          <Content />
        </RouteContext.Provider>
      </SnackbarProvider>
    </DataContext.Provider>
  );
};
